import React from "react";
import "./skills.css";

const Skills = () => {
  const skillList = [
    "HTML",
    "CSS",
    "JavaScript",
    "PHP",
    "MySQL",
    "React",
    "GitHub",
    "Canva",
    "UI Design",
  ];

  return (
    <section className="skills" id="skills">
      <div className="skills__title">
        <div className="skills__typography">
          <h2>skills skills skills</h2>
          <h2>skills skills skills</h2>
          <h2>skills skills skills</h2>
        </div>
      </div>
      <div className="skills__container">
        <ul className="skills__list">
          {skillList.map((skill, index) => (
            <li key={index} className="skills__item">
              <span>{skill}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Skills;
